const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.26583 101.44937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m83.95514,84.72857c-6.94348,4.96636-15.45034,7.88947-24.63692,7.88947-23.41413,0-42.39882-18.9847-42.39882-42.39882,0-23.41676,18.9847-42.39882,42.39882-42.39882s42.39882,18.98206,42.39882,42.39882",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "38.98755 30.27419 60.56413 51.70505 73.67979 44.21001",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.31822,
    y1: 16.32988,
    x2: 59.31822,
    y2: 16.32988,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.41325,
    y1: 47.29317,
    x2: 93.41325,
    y2: 47.29317,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.06326,
    y1: 47.29317,
    x2: 26.06326,
    y2: 47.29317,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.81791,68.01535l-13.09835,7.56087c-4.45785,2.57754-7.40671.94599-21.60236-2.12313l-2.65739,1.53441,11.52122,7.94389-2.32035,1.34305c-.57145.32859-.27446,1.20582.37717,1.12009,17.11617-2.26329,25.22563-5.46934,25.22563-5.46934l37.65543-21.73927s12.99013-7.49796,7.82392-9.38408c-5.73795-2.09738-17.59629,4.58919-17.59629,4.58919l-14.49879,8.37226-24.01396-8.41235-1.45746.84006,17.21327,15.86467",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.12857 73.01594 102.19136 81.40547 99.96845 83.13124 94.59069 78.07359",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemora);
export default __webpack_public_path__ + "static/media/demora.5e83c9ea809c2cc91f67fd435c0bbbb5.svg";
export { ForwardRef as ReactComponent };